<div class="caption-bar">
  <div class="caption">Ablage</div>
</div>
<lib-files></lib-files>
